<script lang="ts" setup>
  const props = defineProps<{
    index: number
    countLabel?: string
    isRemovable?: boolean
  }>()

  const emit = defineEmits<{
    (event: 'remove', index: number): void
  }>()

  function removeHandler() {
    if (!props.isRemovable) return

    emit('remove', props.index)
  }
</script>

<template>
  <fieldset class="c-gift-card-recipient-item">
    <div class="recipient-header">
      <h5 class="recipient-title header-5-small">Gift card recipient</h5>
      <h5 v-if="countLabel" class="recipient-title-count header-5-small">{{ countLabel }}</h5>

      <icon-ionic-trash-bin
        :class="[
          'icon-delete',
          {
            'removable': isRemovable,
            'disabled': !isRemovable
          }
        ]"
        :color="isRemovable ? 'var(--color-base-black)' : 'var(--color-text-muted)'"
        height="1.5rem"
        width="1.5rem"
        @click.stop.prevent="removeHandler"
      />
    </div>

    <CInputTextField :maxlength="64" :name="`recipients.${props.index}.name`" label="Recipient's Name" />
    <CInputTextField
      :maxlength="254"
      :name="`recipients.${props.index}.emailAddress`"
      label="Recipient's Email"
      type="email"
    />
  </fieldset>
</template>

<style lang="scss" scoped>
  .c-gift-card-recipient-item {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;

    .recipient-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      min-height: 34px;

      color: var(--color-text-muted);

      .recipient-title-count {
        margin-left: 0.75rem;
        flex: 1;
      }

      .icon-delete.removable {
        cursor: pointer;
      }

      .icon-delete.disabled {
        cursor: not-allowed;
      }
    }
  }
</style>
